import {
  notifyError,
  useNotifications,
  notifySuccess,
} from 'Logic/Notifications.js'
import { useDataSubmit, useDataValue, useDataChange } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { useMutation } from 'Data/Api.js'

import mutationMigrateTasks from './mutation-migrate-tasks.graphql.js'

export function useOnSubmit(props) {
  let [, executeMigrateTasksMutation] = useMutation(mutationMigrateTasks)

  let [, notify] = useNotifications()

  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'boards',
  })
  let change = useDataChange({
    viewPath: props.viewPath,
    path: 'selected.isSubmitting',
    context: 'tab',
  })

  return async function onSubmit() {
    change(true)
    let mutationResponse = await executeMigrateTasksMutation()

    change(false)
    if (mutationResponse.error || !mutationResponse.data.tasks_migrate.ok) {
      return notify(notifyError('An error has occurred migrating the tasks.'))
    }

    setFlowTo(normalizePath(props.viewPath, '../No'))

    submit({ type: 'refetch' })

    return notify(
      notifySuccess('Your tasks and tasks baskets were migrated successfully')
    )
  }
}

export function useIsDisabled(props) {
  let isSubmitting = useDataValue({
    viewPath: props.viewPath,
    path: 'selected.isSubmitting',
    context: 'tab',
  })

  return isSubmitting
}
